import React from 'react';
import styled from "styled-components";

const WrapperStyled = styled.div`
  margin: 10px 10px 0 10px;
  position: relative;
  padding: 5px;
`;

const ChildrenStyled = styled.div`
  display: grid;
  grid-gap: 10px;

  button {
    height: 30px;
  }
`;

const LabelStyled = styled.div`
  position: absolute;
  top: -16px;
  font-size: 12px;
  font-weight: 600;
  width: 100%;
  text-align: center;
`;

const CoolButtonGroup = ({children, label}) => {
    const numberOfChildren = children?.length || 0;

    return (
        <WrapperStyled>
            <LabelStyled>
                {label}
            </LabelStyled>
            <ChildrenStyled
                style={{
                    gridTemplateColumns: `repeat(${numberOfChildren}, auto)`
                }}
            >
                {children}
            </ChildrenStyled>
        </WrapperStyled>
    );
};

export default CoolButtonGroup;